import { buildQueryParams } from "../support/helpers";
import { dataSystemsAPI } from "./dataSystemsAPI";

/**
 * Creates RTK 'useQuery' hooks for the endpoints defined in the 'endpoints'
 * object.
 */
export const agentEndpoints = dataSystemsAPI.injectEndpoints({
    reducerPath: "nicheItemEndpoints",
    overrideExisting: false,
    endpoints: (builder) => ({
        getAgent: builder.query({
            query: ({ agentSlug }) => ({
                url: `/agents/${agentSlug}`,
                method: "GET",
            }),
            transformResponse: (response) => ({
                agentId:
                    response?.agent?.agentInfo?.agent_name?.more
                        ?.internalAgentID,
                ...response?.agent,
            }),
        }),
        getFeaturedAgent: builder.query({
            query: ({
                listingID,
                niche_item_id,
                development_id,
                state_code,
                broker_agent_id,
                agentType,
            }) => {
                const query = buildQueryParams({
                    listingID,
                    niche_item_id,
                    development_id,
                    state_code,
                    broker_agent_id,
                    agentType,
                    type: broker_agent_id ? "ByID" : undefined,
                });
                let url = `/agents/featured${query}`;
                return {
                    url,
                    method: "GET",
                };
            },
        }),
        getAgentListings: builder.query({
            query: ({ agentId }) => ({
                url: `/agents/${agentId}/listings`,
                method: "GET",
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetAgentQuery,
    useGetFeaturedAgentQuery,
    useGetAgentListingsQuery,
} = agentEndpoints;
